import { CircleCheck, CircleOff, ClockAlert, LoaderCircle } from 'lucide-react';
import type { Device } from '../types';
import { getCameraPresentationStatus } from '../utils/cameraStatus';

const icons = {
  online: CircleCheck,
  offline: CircleOff,
  checking: LoaderCircle,
  stale: ClockAlert,
};

export function CameraOverallBadge({ device, compact = false }: { device: Device; compact?: boolean }) {
  const status = getCameraPresentationStatus(device);
  const Icon = icons[status.state];
  return (
    <span className={`status-badge status-badge--${status.state} ${compact ? 'status-badge--compact' : ''}`}>
      <Icon className={status.state === 'checking' ? 'spin' : undefined} size={14} strokeWidth={2.2} aria-hidden="true" />
      <span>{status.label}</span>
    </span>
  );
}
